import React, { Component } from 'react'
import { CSSTransition } from 'react-css-transition'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import TimeSlotSelector from './TimeSlotSelector'
import Button from '../components/Button'
import Spinner from '../components/Spinner'
import ErrorBlock from '../components/ErrorBlock'
import BookingLib from '../lib/booking'
import AuthenticatedAPI from '../lib/authenticatedAPI'

class BookingEdit extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      booking: {},
      selectedTimeConflicted: false,
      workingHours: [],
      overrideHours: [],
      capacityLimit: null
    }
    this.updateBooking = this.updateBooking.bind(this)
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
    this.selectedTimeChanged = this.selectedTimeChanged.bind(this)
    this.selectedTimeConflicted = this.selectedTimeConflicted.bind(this)
    this.selectedDateChanged = this.selectedDateChanged.bind(this)
  }

  
  componentWillMount() {
    window.scrollTo(0, 0); // TODO avoid duplication on all pages
  }
  
  async componentDidMount() {

    try {
      this.setState({ isLoading: true })

      // Fetch working hours, override Hours & capcaity limit
      const [
        booking,
        workingHoursObject, 
        overrideHours,
        futureBookingLimit,
        capacityLimit
      ] = await Promise.all([
        this.getBooking(),
        BookingLib.getSettings('workingHours'), 
        BookingLib.getOverrides(),
        BookingLib.getSettings('futureBookingLimit'),
        BookingLib.getSettings('capacityLimit')
      ])
  
      // If successful map working hours to state in desired form
      const workingHours = BookingLib.mapWeekStartToSunday(workingHoursObject.settingValue.days)
  
      this.setState({
        booking,
        workingHours,
        overrideHours,
        futureBookingLimit,
        capacityLimit: capacityLimit ? +capacityLimit.settingValue.value : 3
      })
    } catch(e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false })
    }
  }
  
  getKey() {
    this.keyCount += 1
    return this.keyCount
  }
  
  async getBooking() {
    const { props } = this
    const { id } = props.match.params
      
    const usersBookings = await AuthenticatedAPI.get('cphill', '/users/bookings')
    const booking = usersBookings.find(b => b.id === +id)

    // NOTE: Frontend booking obj and backend booking obj is not completely aligned
    // TODO: Fix :-)
    return {
      ...booking,
      whenStartTime: booking.dateStart,
      whenEndTime: booking.dateEnd
    }
  }

  selectedTimeChanged(startTime, endTime) {
    const { booking } = this.state
    // console.log({booking, startTime, endTime})
    // booking.whenStartTime = startTime
    // booking.whenEndTime = endTime
    this.setState({ 
      booking: {
        ...booking,
        whenStartTime: startTime,
        whenEndTime: endTime
      }
    })
  }
  
  selectedTimeConflicted(value) {
    this.setState({ selectedTimeConflicted: value })
  }

  isValid() {
    const { booking, selectedTimeConflicted, workingHours, overrideHours } = this.state
    return (
      booking.whenStartTime
      && booking.whenEndTime
      && !BookingLib.timeIsOutOfBounds(booking.whenEndTime, workingHours, overrideHours)
      && !selectedTimeConflicted
    )
  }

  selectedDateChanged(bookingDate) {
    this.setState({ bookingDate })
  }

  async updateBooking() {
    const { props, state } = this
    this.setState({ isLoading: true, error: null })

    try {
      await AuthenticatedAPI.put('cphill', `/bookings/${state.booking.id}`, {
        dateStart: state.booking.whenStartTime,
        dateEnd: state.booking.whenEndTime
      })
      props.history.push('/dashboard')
    } catch (e) {
      let { error } = e.response.data
      if (typeof error === 'string') {
        error = { name: e.name, message: error }
      }
      this.setState({ error })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { state } = this

    // Strange fix - throws an error in console without this
    // https://github.com/wikiwi/react-css-transition/issues/5
    CSSTransition.childContextTypes = {}

    return (
      <>
        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mx-auto">
            <h4 className="text-harbor-80 uppercase text-sky">
              <FormattedMessage
                id="booking.edit.category"
                defaultMessage="Edit booking"
              />
            </h4>

            <h1 className="border-b pb-6">
              <FormattedMessage
                id="booking.edit.header"
                defaultMessage="Select new time"
              />
            </h1>

            {state.error && (
              <ErrorBlock headerText={state.error.name} descriptionText={state.error.message || 'Something wrong happened :-('} />
            )}
          </div>
        </div>

        {state.isLoading ? (
          <Spinner />
        ) : (
          <>
            <TimeSlotSelector
              booking={state.booking}
              getKey={this.getKey}
              selectedTimeChanged={this.selectedTimeChanged}
              selectedTimeConflicted={this.selectedTimeConflicted}
              showTimeSlotNotSelectedError={state.showTimeSlotNotSelectedError}
              showDateNotSelectedError={state.showDateNotSelectedError}
              selectedDateChanged={this.selectedDateChanged}
              workingHours={state.workingHours}
              overrideHours={state.overrideHours}
              futureBookingLimit={state.futureBookingLimit}
              capacityLimit={state.capacityLimit}
              disableDurationSelection
            />

            <div className="container mx-auto flex md:w-2/3 lg:w-1/2 mb-16 mt-12 p-4 md:p-0">
              <div className="flex-grow">
                <Link
                  to="/dashboard"
                  className="inline-flex text-lg py-4 px-8 italic rounded-full uppercase font-bold leading-normal bg-grey text-harbor"
                >
                  <FormattedMessage
                    id="booking.whenForm.buttonBack"
                    defaultMessage="Back"
                  />
                </Link>
              </div>
              
              <Button
                onClick={this.updateBooking}
                className={`${this.isValid() ? '' : 'opacity-50 cursor-not-allowed'}`}
              >
                <FormattedMessage
                  id="booking.edit.buttonSave"
                  defaultMessage="Update"
                />
              </Button>
            </div>
          </>
        )}
      </>
    )
  }
}

export default BookingEdit